import { Box } from '@mui/material';

import PrescribingHeader from '../components/PrescribingHeader';
import OrderStateFilter from '../components/OrderStateFilter';

export default function OrderListLayout({ children }) {
  return (
    <>
      <PrescribingHeader allowClinicChange />
      <Box className="grow flex flex-col gap-12 pt-8 pb-20 px-8 bg-white overflow-hidden">
        <Box className="flex">
          <OrderStateFilter />
        </Box>
        {children}
      </Box>
    </>
  );
}
